import React from 'react';
import './style.sass';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { MenuCredito } from 'components/menuCredito';
import { Error500 } from 'components/Error/Error500';
import AceptarCreditoCS from '../AceptarCreditoCS';

export default function HomeDesktop(props) {
    const {
        setAddCard,
        errorCode,
        creditoAutorizado,
        isMobile,
        aceptarCredito,
        loading
    } = props;


    return (
        <>
            <Header type="complete"/>
            <main>
                <section className="sectionPrincipal">
                    <MenuCredito />
                    {errorCode >= 500
                        ? <Error500 />
                        :
                            <div className="contenido">
                                <div className="boxGeneralHomeDesk">
                                {!loading
                                    ?<AceptarCreditoCS creditoAutorizado={creditoAutorizado} isMobile={isMobile} aceptarCredito={aceptarCredito}/>
                                    :null
                                }
                                </div>
                            </div>
                    }
                </section>
            </main>
            <Footer type="complete"/>
        </>
    )
}